import "../../index.css";
import { ValuationsFormPage } from "./valuations-form-page.tsx";
import { reactHydrate } from "../../react-hydrate.ts";

window.Components = {
  ValuationsFormPage: ValuationsFormPage,
};

reactHydrate();
